import { render, staticRenderFns } from "./PatrolItemDrawer.vue?vue&type=template&id=2a8566ac&scoped=true&"
import script from "./PatrolItemDrawer.vue?vue&type=script&lang=js&"
export * from "./PatrolItemDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PatrolItemDrawer.vue?vue&type=style&index=0&id=2a8566ac&lang=scss&scoped=true&"
import style1 from "./PatrolItemDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8566ac",
  null
  
)

export default component.exports